/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StoreOrderingDeactivationsResponse } from '../../models/store-ordering-deactivations-response';

export interface GetStoreOrderingDeactivations$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
}

export function getStoreOrderingDeactivations(http: HttpClient, rootUrl: string, params: GetStoreOrderingDeactivations$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreOrderingDeactivationsResponse>> {
  const rb = new RequestBuilder(rootUrl, getStoreOrderingDeactivations.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoreOrderingDeactivationsResponse>;
    })
  );
}

getStoreOrderingDeactivations.PATH = '/stores/{storeId}/ordering-deactivations/current';
